var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("Card", [
    _c(
      "div",
      { staticClass: "card-block" },
      [
        _c("div", { staticClass: "table-action" }, [_vm._t("table-action")], 2),
        _vm._v(" "),
        _vm._t("table-container", [
          _c(
            "div",
            { staticClass: "responsive-table-container" },
            [
              _vm._t("table", [
                _c(
                  "table",
                  { staticClass: "table" },
                  [_vm._t("thead"), _vm._v(" "), _vm._t("tbody")],
                  2
                )
              ])
            ],
            2
          )
        ])
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-62ce5cfe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62ce5cfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TableCard.vue
// module id = Xi+Y
// module chunks = 1